import {
  StyleSheet,
  ImageBackground,
  SafeAreaView,
  useWindowDimensions,
} from "react-native";
import React, { useEffect, useState } from "react";
import {
  View,
  ScrollView,
  Text,
  Heading,
  Box,
  VStack,
  HStack,
  Pressable,
} from "native-base";
import { StackScreenProps } from "../../types";
import Card, { CardProps } from "../../components/Card";
import { LinearGradient } from "expo-linear-gradient";
import Header from "../../components/Header";
import CountUp from "react-countup";
import AsyncStorage from "@react-native-async-storage/async-storage";

const Media = ({ navigation }: StackScreenProps<"Media">) => {
  const { width, height } = useWindowDimensions();
  const ffr = require("../../assets/fortune_radio.png");

  const [data, setData] = useState({});
  useEffect(() => {
    async function getData() {
      const items = await AsyncStorage.getItem("keyFigures");

      if (items) {
        try {
          setData(JSON.parse(items));
          // console.log(JSON.parse(items));
        } catch (error) {
          console.log(error);
        }
      }
    }

    getData();
  }, []);

  return (
    <ImageBackground source={ffr} resizeMode="cover" style={{ width, height }}>
      <View style={styles.overlay}>
        <SafeAreaView style={{ height }}>
          <ScrollView>
            <Header
              onPress={() => navigation.navigate("Media")}
              parentText="Media"
              headingText="Farm & Fortune Radio Show"
            />

            <Text mb={5} textAlign="center" fontWeight={"bold"}>
              Key figures:
            </Text>

            <Box
              width={"5/6"}
              mb={5}
              marginX="auto"
              // borderBottomColor="#000"
              borderColor={"#ccc"}
              borderWidth="1"
              borderRadius={15}
              p={5}
              px={2}
              pb={2}
            >
              <HStack justifyContent={"space-between"}>
                <View w={"30%"}>
                  <Text
                    fontWeight={"extrabold"}
                    fontSize="2xl"
                    textAlign={"center"}
                  >
                    <CountUp
                      delay={0}
                      end={data["ffhradio_1"]}
                      duration={3}
                      suffix="M+"
                    />
                  </Text>
                  <Text fontWeight={"bold"} textAlign={"center"}>
                    Listeners
                  </Text>
                </View>
                <View w={"30%"}>
                  <Text
                    fontWeight={"extrabold"}
                    fontSize="2xl"
                    textAlign={"center"}
                  >
                    <CountUp delay={0} end={data["ffhradio_2"]} />
                  </Text>
                  <Text fontWeight={"bold"} textAlign={"center"}>
                    Episodes
                  </Text>
                </View>
                <View w={"30%"}>
                  <Text
                    fontWeight={"extrabold"}
                    fontSize="2xl"
                    textAlign={"center"}
                  >
                    <CountUp delay={0} end={data["ffhradio_3"]} />
                  </Text>
                  <Text fontWeight={"bold"} textAlign={"center"}>
                    Local Languages
                  </Text>
                </View>
              </HStack>
            </Box>

            <Text textAlign="center" px={5}>
              The Farm & Fortune project employs the use of radio communication
              to reach farmers in rural communities by creating tailor made
              content in local languages for ease of understanding.
            </Text>

            <View mt={10}></View>
          </ScrollView>
        </SafeAreaView>
      </View>
    </ImageBackground>
  );
};

export default Media;

const styles = StyleSheet.create({
  overlay: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
  },
  cardOverlay: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: "rgba(0, 0, 0, 0.2)",
  },
});
